/* @flow */

import * as React from 'react';
import styled from 'styled-components';

import FlexBox from '../../FlexBox';
import Container from '../../Container';
import zIndexScale from '../../../utils/zIndexScale';
import UserBaseInfo from '../UserBaseInfo';
import Navs from './Navs';
import ReferralEntry from './ReferralEntry';

const FIXED_HEADER_HEIGHT = 60;
const DEFAULT_TRANSLATE_Y = 0;
const MAX_TRANSLATE_Y = 80;

const Wrap = styled.div`
  width: 100%;
  min-height: 198px;
  background: #fff;
`;

const UserInfoBox = styled(FlexBox)`
  width: 100%;
`;


const Content = styled.div`
  width: 100%;
  padding-top: 30px;
  background: rgba(11,14,17,0.96);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
  ${({ isFixed }) => (isFixed ? `position:fixed;z-index:${zIndexScale.topNav};` : 'position: relative;z-index: 9;')}
  left: 0;
  top: 0;
  ${({ translate }) => `transform: translateY(${translate}px)`};
  transition: transform 0.3s ease;
`;

type Props = {};

type State = {
  isFixed: boolean,
  translate: number,
};

export default class Header extends React.PureComponent<Props, State> {
  state = {
    isFixed: false,
    translate: DEFAULT_TRANSLATE_Y,
  };

  componentDidMount() {
    window.addEventListener('scroll', this._scroll);
  }

  _scroll = () => {
    const { documentElement }: Document = document;
    // $FlowFixMe
    const { scrollTop } = documentElement;
    const isFixed = scrollTop >= FIXED_HEADER_HEIGHT;
    let translate = DEFAULT_TRANSLATE_Y;
    if (isFixed) {
      translate = DEFAULT_TRANSLATE_Y - (scrollTop - this.state.translate) * 0.8;
    }
    this.setState({
      isFixed,
      translate: Math.abs(translate) > MAX_TRANSLATE_Y ? -MAX_TRANSLATE_Y : translate,
    });
  };

  render() {
    const { translate } = this.state;
    return (
      <Wrap>
        <Content isFixed={this.state.isFixed} translate={translate}>
          <Container>
            <UserInfoBox justify="space-between" align="center">
              <UserBaseInfo />
              <ReferralEntry />
            </UserInfoBox>
          </Container>
          <FlexBox margin="10px 0 0">
            <Navs />
          </FlexBox>
        </Content>
      </Wrap>
    );
  }
}
